import { Typography, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
  title: string | undefined;
  buttonToRender?: JSX.Element;
}

const HeaderPortal = ({ title, buttonToRender }: PortalProps) => {
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return (
    portalHeader &&
    ReactDOM.createPortal(
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {title}
        </Typography>
        {buttonToRender}
      </Grid>,
      portalHeader
    )
  );
};

export default HeaderPortal;
